export class StringUtils {
  /**
   * Trims the string, transforms it to lower case, and removes combining diacritical marks from it.
   * https://en.wikipedia.org/wiki/Combining_Diacritical_Marks
   *
   * normalize() to NFD Unicode normal form decomposes combined graphemes into the combination of simple ones.
   * ie: The è of Crème ends up expressed as e + ̀.
   *
   * replace() uses a regex to match the U+0300 → U+036F char’s range in the Unicode standard that refers to Combining Diacritical Marks
   * http://unicode.org/charts///PDF/Unicode-3.2/U32-0300.pdf
   *
   * @param string - The string to normalize.
   * @returns The normalized version of the string.
   */
  public static normalize(string: string): string {
    return string.normalize('NFD')
                 .replace(/[\u0300-\u036f]/g, '')
                 .trim()
                 .toLowerCase();
  }

}
